<template>
	<div
		id="pilotsView"
		:class="{ animate: animateView }"
		:style="{ 'animation-delay': animationDelay }"
		class="content-container carousel-view"
	>
		<Carousel
			:animate="animate"
			:items="pilots"
			:roster-image="p => p.portrait"
			:roster-label="p => p.callsign"
			:roster-title="p => p.name"
			:max-card-height="760"
			empty-text="// NO PILOT RECORDS ON FILE //"
			v-slot="{ item }"
		>
			<Pilot :pilot="item" :animate="animate" />
		</Carousel>
	</div>
</template>

<script>
import Carousel from "@/components/Carousel.vue";
import Pilot from "@/components/Pilot.vue";

export default {
	components: {
		Carousel,
		Pilot,
	},
	props: {
		animate: {
			type: Boolean,
			required: true,
		},
		pilots: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			animateView: this.animate,
			animationDelay: "0s",
		};
	},
};
</script>
